import { produce } from 'immer';
import { Platform } from 'react-native';
import {
	MENU_RESIZE,
	SECOND_MENU_CONTEXT,
	SECOND_MENU_TOGGLE,
	CLOSE_SECOND_MENU,
	MENU_OPEN,
	MENU_CLOSE,
	CHANGE_THEME_ACCENT,
	TOGGLE_OTP,
	TOGGLE_MENU_WARPER,
	CLOSE_MENU_WARPER,
	INITIALISE_MENU,
	CLOSE_MENU,
	CURRENT_PAN,
	ACHIEVEMENT_POINTS_ADDED,
	ACHIEVEMENT_ANIMATION_END,
	DISMISSED_APP_INFO,
	TOGGLE_CONTEXT,
	TOGGLE_AI,
	TOGGLE_FOCUS_MODE,
	LOADING_MESSAGES,
	SHOW_STICKY_WIDGET,
	BEGAN_ARROW_DRAG,
	STOPPED_ARROW_DRAG,
	SHOW_OTP,
	SET_ACTIVE_WHATSAPP_NUMBER,
	SET_AVAILABLE_WHATSAPP_NUMBERS,
	HIDE_OTP,
	NOTIFICATION_RECEIVED,
	NOTIFICATIONS_ACKNOWLEDGED,
	UPDATED_INVITATIONS,
	UPDATED_MESSAGES,
	UPDATED_CALENDAR_ENTRIES,
	MESSAGES_OPEN,
	MESSAGES_CLOSED,
	RESET_INVITATIONS,
	INITIALISE_INVITATIONS,
	CHANGE_MENU,
	OPEN_QUICK_ACTIONS,
	CLOSE_QUICK_ACTIONS,
	OPEN_MENU,
	CONTEXT_SIZE_TOGGLE,
	HEADER_HEIGHT,
	STATUSBAR_HEIGHT,
	SET_MESSAGE_APP_FILTER,
	SET_MESSAGE_EXTERNAL_FILTER,
	UPDATE_MAIL_COUNT,
	USER_HIERARCHY_FOCUSED,
	SET_SALES_DATE_FILTER,
	TOGGLE_GLOBAL_HIERARCHY,
	RESET_GLOBAL_HIERARCHY,
	SET_DATAFILTER,
	SET_UPLOADER_STAGE,
	SET_DRAGGED_USER,
	CLEAR_DRAGGED_USER,
	TOGGLE_ADVANCED_MODE,
	TOGGLE_EASY_MODE,
	START_ONBOARDING,
	COMPLETE_ONBOARDING,
	SKIP_ONBOARDING,
	OPEN_CONTEXT,
	CLOSE_CONTEXT,
	UPDATE_PAGE_BADGES,
	CLEAR_PAGE_BADGES,
	UPDATE_ENTITY_BADGE,
	CLEAR_ENTITY_BADGE,
	FORCE_FOCUS_MODE,
	SET_FOCUS_MODE_PROGRESS,
	SET_FEED_RECOMMENDED_EXPANDED,
	CHANGE_GLOBAL_DATE_FORMAT,
	LOADED_MESSAGES,
	UPDATE_REVIEW_REQUESTED,
	PAYMENT_REQUIRED,
	HIDE_PAYMENT_REQUIRED,
	SHOW_TAMAGUI_CARD,
	HIDE_TAMAGUI_CARD,
	TOGGLE_TAMAGUI_CARD,
	SET_TAMAGUI_CARD_VISIBILITY,
	SET_RECOMMENDED_INTEGRATIONS,
	STORE_BUSINESS_PROMPT,
	CLEAR_BUSINESS_PROMPT,
} from '../actions/types';
import { updateObject } from './utils/globalStateFunctions';

const initialState = {
	menuOpen: Platform.OS === 'web' && window.innerWidth > 400 ? true : false,
	menuWasOpen: null,
	secondaryMenuOpen: 0,
	secondaryMenuContext: { active: false, content: [] },
	drawerState: '',
	menuTransitioning: false,
	showOTP: false,
	menuWarper: false,
	quickActions: false,
	lastAppReviewPrompt: Date.now(),
	pannedView: false,
	pannedViewDetails: null,
	messageAppFilter: 'default',
	messageExternalFilter: false, // false = team, true = external
	achievementAdded: false,
	appInfo: true,
	dateFormat: 'Do MMM YYYY',
	contextAvailable: false,
	contextMinimized: false,
	aiAvailable: false,
	lastNotification: null,
	advancedMode: false,
	easyMode: false,
	onboardingInProgress: false,
	focusMode: false,
	focusModeProgress: 0,
	focusModeManuallyControlled: false,
	/** Persisted: feed "Recommended for you" rail expanded (web). */
	feedRecommendedExpanded: true,
	previousFocusMode: false,
	stickyNoteWidget: false,
	arrowDragged: false,
	draggedUser: null,
	uploaderStage: 0,
	messagesOpen: false,
	notification: false,
	loadingMessages: false,
	dataFilter: 'all',
	paymentRequiredVisible: false,
	paymentRequired: false,
	paymentMessage: null,
	tamaguiCardVisible: false,
	recommendedIntegrations: [], // Array of integration metas/IDs recommended during onboarding
	businessPrompt: null, // Stored prompt from landing page for business builder
	messageOptions: {
		activeWhatsappNumber: '',
		whatsappNumbers: [],
	},
	badges: {
		welcome: 0,
		data: 0,
		sales: 0,
		projectmanagement: 0,
		organiser: 0,
		reports: 0,
		company: 0,
		knowledge: 0,
		integrations: 0,
		settings: 0,
		academy: 0,
		ai: 0,
		agenttasks: 0,
	},
	/** Unread change counts keyed by dataset or project id. */
	entityBadges: {
		data: {} as Record<string, number>,
		projects: {} as Record<string, number>,
	},
	agentBadges: {
		welcome: [],
		data: [],
		sales: [],
		projectmanagement: [],
		organiser: [],
		reports: [],
		company: [],
		knowledge: [],
		integrations: [],
		settings: [],
		academy: [],
		ai: [],
		agenttasks: [],
	},
	salesDateFilter: { label: 'month', value: 'month' },
	userHierarchyFocused: false,
	hideRobots: false,
	userHierarchyGlobal: true,
	static: { statusBarHeight: 70, headerHeight: 70 },
	counts: { messageCount: 0, invitationCount: 0, calendarCount: 0 },
	calendarLoading: false,
};

export default function (state = initialState, action) {
	switch (action.type) {
		case 'MENU_STATE_CHANGING':
			return updateObject(state, {
				menuTransitioning: true,
			});
		case 'MENU_STABILISED':
			return updateObject(state, {
				menuTransitioning: false,
			});
		case 'CALENDAR_LOADING':
			return updateObject(state, {
				calendarLoading: true,
			});
		case 'CALENDAR_STOPPED_LOADING':
			return updateObject(state, {
				calendarLoading: false,
			});
		case CLOSE_MENU:
			return updateObject(state, {
				...state,
				menuOpen: false,
			});
		case MESSAGES_OPEN:
			return updateObject(state, {
				...state,
				messagesOpen: action.payload,
			});
		case MESSAGES_CLOSED:
			return updateObject(state, {
				...state,
				messagesOpen: false,
			});
		case LOADING_MESSAGES:
			return updateObject(state, {
				loadingMessages: true,
			});
		case 'PAYMENT_SATISFIED':
			return updateObject(state, {
				paymentRequired: false,
				paymentRequiredVisible: false,
			});
		case PAYMENT_REQUIRED:
			return updateObject(state, {
				paymentRequired: true,
				paymentRequiredVisible: true,
				paymentMessage:
					action.payload?.body || action.payload?.message || null,
			});
		case HIDE_PAYMENT_REQUIRED:
			return updateObject(state, {
				paymentRequired: false,
				paymentRequiredVisible: false,
				paymentMessage: null,
			});
		case LOADED_MESSAGES:
			return updateObject(state, {
				loadingMessages: false,
			});
		case UPDATE_REVIEW_REQUESTED:
			return updateObject(state, {
				...state,
				lastAppReviewPrompt: Date.now(),
			});
		case CHANGE_GLOBAL_DATE_FORMAT:
			return updateObject(state, {
				...state,
				dateFormat: action.payload,
			});
		case FORCE_FOCUS_MODE:
			return updateObject(state, {
				...state,
				focusMode: true,
				focusModeManuallyControlled: true,
			});
		case SET_FOCUS_MODE_PROGRESS:
			// Only update if focus mode is not manually controlled
			if (state.focusModeManuallyControlled) {
				return state;
			}
			return updateObject(state, {
				...state,
				focusModeProgress: action.payload,
				focusMode: action.payload > 0.3, // Enable focus mode when progress > 30%
			});
		case SET_FEED_RECOMMENDED_EXPANDED:
			return updateObject(state, {
				...state,
				feedRecommendedExpanded: Boolean(action.payload),
			});
		case TOGGLE_FOCUS_MODE:
			return updateObject(state, {
				...state,
				focusMode: !state.focusMode,
				previousFocusMode: !state.focusMode,
				focusModeManuallyControlled: !state.focusMode, // Set to true when manually enabled, false when disabled
				focusModeProgress: !state.focusMode ? 1 : 0, // Reset progress based on new state
			});
		case UPDATE_PAGE_BADGES:
			const currentAgentBadges = state.agentBadges?.[action.payload.page] || [];
			let newAgentBadges = [...currentAgentBadges];
			if (action.payload.agents && Array.isArray(action.payload.agents)) {
				action.payload.agents.forEach((agent: any) => {
					const exists = newAgentBadges.some((a: any) => 
						(a._id && a._id === agent._id) || 
						(a.type && a.type === agent.type)
					);
					if (!exists) {
						newAgentBadges.push(agent);
					}
				});
			} else if (action.payload.agent) {
				const exists = newAgentBadges.some((a: any) => 
					(a._id && a._id === action.payload.agent._id) || 
					(a.type && a.type === action.payload.agent.type)
				);
				if (!exists) {
					newAgentBadges.push(action.payload.agent);
				}
			}
			
			return updateObject(state, {
				badges: {
					...state.badges,
					[action.payload.page]:
						(state.badges[action.payload.page] || 0) +
						action.payload.count,
				},
				agentBadges: {
					...state.agentBadges,
					[action.payload.page]: newAgentBadges,
				}
			});
		case CLEAR_PAGE_BADGES:
			return updateObject(state, {
				badges: {
					...state.badges,
					[action.payload]: 0,
				},
				agentBadges: {
					...state.agentBadges,
					[action.payload]: [],
				}
			});
		case UPDATE_ENTITY_BADGE: {
			const kind = action.payload?.kind;
			const id = action.payload?.id != null ? String(action.payload.id) : '';
			const count = Number(action.payload?.count) || 0;
			if ((kind !== 'data' && kind !== 'projects') || !id || count === 0) {
				return state;
			}
			const entityBadges = state.entityBadges || { data: {}, projects: {} };
			const bucket = { ...(entityBadges[kind] || {}) };
			bucket[id] = (Number(bucket[id]) || 0) + count;
			return updateObject(state, {
				entityBadges: {
					...entityBadges,
					[kind]: bucket,
				},
			});
		}
		case CLEAR_ENTITY_BADGE: {
			const kind = action.payload?.kind;
			const id = action.payload?.id != null ? String(action.payload.id) : '';
			if ((kind !== 'data' && kind !== 'projects') || !id) {
				return state;
			}
			const entityBadges = state.entityBadges || { data: {}, projects: {} };
			if (!entityBadges[kind]?.[id]) return state;
			const bucket = { ...entityBadges[kind] };
			delete bucket[id];
			return updateObject(state, {
				entityBadges: {
					...entityBadges,
					[kind]: bucket,
				},
			});
		}
		case 'HIDE_ROBOT':
			return updateObject(state, {
				hideRobots: true,
			});
		case TOGGLE_ADVANCED_MODE:
			return updateObject(state, {
				...state,
				advancedMode: !state.advancedMode,
			});
		case TOGGLE_EASY_MODE:
			console.log(
				`🔴 REDUX ACTION: TOGGLE_EASY_MODE. New easyMode state: ${!state.easyMode}`
			);
			// Prevent toggling if onboarding is in progress
			if (state.onboardingInProgress) {
				return state;
			}
			return updateObject(state, {
				...state,
				easyMode: !state.easyMode,
			});
		case START_ONBOARDING:
			return updateObject(state, {
				...state,
				onboardingInProgress: true,
				focusMode: true,
				focusModeManuallyControlled: true,
			});
		case COMPLETE_ONBOARDING:
			return updateObject(state, {
				...state,
				onboardingInProgress: false,
				focusMode: false, // Turn off focus mode when onboarding completes
				focusModeManuallyControlled: false,
				focusModeProgress: 0,
				previousFocusMode: false,
			});
		case SKIP_ONBOARDING:
			return updateObject(state, {
				...state,
				onboardingInProgress: false,
				focusMode: false, // Turn off focus mode when onboarding is skipped
				focusModeManuallyControlled: false,
				focusModeProgress: 0,
				previousFocusMode: false,
			});
		case SET_DRAGGED_USER:
			return updateObject(state, {
				...state,
				draggedUser: action.payload,
			});
		case CLEAR_DRAGGED_USER:
			return updateObject(state, {
				...state,
				draggedUser: null,
			});
		case SET_MESSAGE_APP_FILTER:
			return updateObject(state, {
				...state,
				messageAppFilter: action.payload,
			});
		case SET_MESSAGE_EXTERNAL_FILTER:
			return updateObject(state, {
				...state,
				messageExternalFilter: action.payload,
			});
		case SET_ACTIVE_WHATSAPP_NUMBER:
			return updateObject(state, {
				...state,
				messageOptions: {
					...state.messageOptions,
					activeWhatsappNumber: action.payload,
				},
			});
		case SET_AVAILABLE_WHATSAPP_NUMBERS:
			return updateObject(state, {
				...state,
				messageOptions: {
					...state.messageOptions,
					whatsappNumbers: action.payload,
				},
			});
		case SET_UPLOADER_STAGE:
			return updateObject(state, {
				uploaderStage: action.payload,
			});
		case SET_DATAFILTER:
			return updateObject(state, {
				...state,
				dataFilter: action.payload,
			});
		case RESET_GLOBAL_HIERARCHY:
			return updateObject(state, {
				...state,
				userHierarchyGlobal: false,
			});
		case TOGGLE_GLOBAL_HIERARCHY:
			return updateObject(state, {
				...state,
				userHierarchyGlobal: !state.userHierarchyGlobal,
			});
		case SET_SALES_DATE_FILTER:
			return updateObject(state, {
				salesDateFilter: action.payload,
			});
		case UPDATE_MAIL_COUNT:
			return updateObject(state, {
				counts: { ...state.counts, messageCount: action.payload },
			});
		case USER_HIERARCHY_FOCUSED:
			return updateObject(state, {
				...state,
				userHierarchyFocused: action.payload,
			});
		case HEADER_HEIGHT:
			return updateObject(state, {
				...state,
				static: { ...state.static, headerHeight: action.payload },
			});
		case STATUSBAR_HEIGHT:
			return updateObject(state, {
				...state,
				static: { ...state.static, statusBarHeight: action.payload },
			});
		case CONTEXT_SIZE_TOGGLE:
			return updateObject(state, {
				...state,
				contextMinimized: !state.contextMinimized,
			});
		case OPEN_CONTEXT:
			return updateObject(state, {
				...state,
				contextMinimized: false,
			});
		case CLOSE_CONTEXT:
			return updateObject(state, {
				...state,
				contextMinimized: true,
			});
		case UPDATED_INVITATIONS:
			return updateObject(state, {
				counts: {
					...state.counts,
					invitationCount:
						action.payload + state.counts.invitationCount,
				},
			});
		case RESET_INVITATIONS:
			return updateObject(state, {
				counts: { ...state.counts, invitationCount: 0 },
			});
		case INITIALISE_INVITATIONS:
			return updateObject(state, {
				counts: { ...state.counts, invitationCount: action.payload },
			});
		case UPDATED_CALENDAR_ENTRIES:
			return updateObject(state, {
				counts: { ...state.counts, calendarCount: action.payload },
			});
		case UPDATED_MESSAGES:
			return updateObject(state, {
				counts: { ...state.counts, messageCount: action.payload },
			});
		case OPEN_QUICK_ACTIONS:
			return updateObject(state, {
				...state,
				quickActions: true,
			});
		case CLOSE_QUICK_ACTIONS:
			return updateObject(state, {
				...state,
				quickActions: false,
			});
		case INITIALISE_MENU:
			return updateObject(state, initialState);
		case DISMISSED_APP_INFO:
			return updateObject(state, {
				appInfo: false,
			});
		case BEGAN_ARROW_DRAG:
			return updateObject(state, {
				...state,
				arrowDragged: true,
			});
		case STOPPED_ARROW_DRAG:
			return updateObject(state, {
				...state,
				arrowDragged: false,
			});
		case TOGGLE_CONTEXT:
			return updateObject(state, {
				...state,
				contextAvailable: action.payload,
			});
		case TOGGLE_AI:
			return updateObject(state, {
				...state,
				aiAvailable: action.payload,
			});
		case MENU_RESIZE:
			const openMenu = state.menuOpen;
			return updateObject(state, {
				...state,
				menuOpen: !openMenu,
				menuWasOpen: !openMenu,
			});
		case CURRENT_PAN: {
			return updateObject(state, {
				...state,
				pannedView: true,
				pannedViewDetails: action.payload,
			});
		}
		case NOTIFICATION_RECEIVED: {
			return updateObject(state, {
				...state,
				notification: true,
				lastNotification: action.payload,
			});
		}
		case NOTIFICATIONS_ACKNOWLEDGED: {
			return updateObject(state, {
				...state,
				notification: false,
			});
		}
		case ACHIEVEMENT_POINTS_ADDED: {
			return updateObject(state, {
				...state,
				achievementAdded: true,
			});
		}
		case ACHIEVEMENT_ANIMATION_END: {
			return updateObject(state, {
				...state,
				achievementAdded: false,
			});
		}
		case TOGGLE_MENU_WARPER:
			return updateObject(state, {
				...state,
				menuWarper: !state.menuWarper,
			});
		case CHANGE_MENU:
			return updateObject(state, {
				...state,
				menuWarper: false,
			});
		case CLOSE_MENU_WARPER:
			return updateObject(state, {
				...state,
				menuWarper: false,
			});
		case SHOW_OTP:
			return updateObject(state, {
				...state,
				showOTP: true,
				heldCredentials: action.payload,
			});
		case HIDE_OTP:
			return updateObject(state, {
				...state,
				showOTP: false,
				heldCredentials: undefined,
			});
		case MENU_OPEN:
			let wasSecondaryMenuOpen = state.secondaryMenuOpen;
			let wasSecondaryMenuContext = state.secondaryMenuContext;
			return updateObject(state, {
				...state,
				secondaryMenuContext: wasSecondaryMenuContext,
				menuOpen: true,
				menuWasOpen: false,
			});
		case MENU_CLOSE:
			return updateObject(state, {
				...state,
				menuOpen: false,
				menuWasOpen: true,
			});
		case SECOND_MENU_TOGGLE:
			return updateObject(state, {
				...state,
				secondaryMenuOpen: state.secondaryMenuOpen + 1,
			});
		case SECOND_MENU_CONTEXT:
			if (Platform.OS != 'web') {
				const returnContentArray = produce(
					state.secondaryMenuContext.content,
					(newContent) => {
						newContent = [];
						action.data?.map((item) => {
							newContent.push(item);
						});
						return newContent;
					}
				);
				return updateObject(state, {
					...state,
					secondaryMenuContext: {
						...state.secondaryMenuContext,
						active: action.data.active,
						content: returnContentArray,
					},
				});
			} else {
				return updateObject(state, {
					...state,
					secondaryMenuContext: {
						...state.secondaryMenuContext,
						active: action.data.active,
						content: action.data,
					},
				});
			}
		case CLOSE_SECOND_MENU:
			return updateObject(state, {
				...state,
				menuOpen: true,
				secondaryMenuContext: { active: false, content: [] },
			});
		case SHOW_TAMAGUI_CARD:
			return updateObject(state, {
				...state,
				tamaguiCardVisible: true,
			});
		case HIDE_TAMAGUI_CARD:
			return updateObject(state, {
				...state,
				tamaguiCardVisible: false,
			});
		case TOGGLE_TAMAGUI_CARD:
			return updateObject(state, {
				...state,
				tamaguiCardVisible: !state.tamaguiCardVisible,
			});
		case SET_TAMAGUI_CARD_VISIBILITY:
			return updateObject(state, {
				...state,
				tamaguiCardVisible: action.payload,
			});
		case SET_RECOMMENDED_INTEGRATIONS:
			return updateObject(state, {
				...state,
				recommendedIntegrations: action.payload || [],
			});
		case STORE_BUSINESS_PROMPT:
			return updateObject(state, {
				...state,
				businessPrompt: action.payload,
			});
		case CLEAR_BUSINESS_PROMPT:
			return updateObject(state, {
				...state,
				businessPrompt: null,
			});
		default:
			return state;
	}
}
